import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AutoUnsubscribeHelperService {
  private componentInstancesCounter: Record<string, number> = {};

  setComponentInstances(componentName: string): void {
    this.componentInstancesCounter[componentName] = (this.componentInstancesCounter[componentName] || 0) + 1;
  }

  checkIfNotMultiComponentInstances(componentName: string): boolean {
    return this.componentInstancesCounter[componentName] <= 1;
  }

  clearComponentInstances(componentName: string): void {
    if (this.componentInstancesCounter[componentName]) {
      this.componentInstancesCounter[componentName]--;
    }
  }
}
